import { useEffect, useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { brl } from "@/lib/api";
import { digits } from "@/lib/shop";
import { fmtPts, rewardSummary } from "@/lib/loyalty";
import { PointsBox } from "./PointsBox";
import { PinGate } from "./PinGate";

// Saldo de pontos buscado só pelo telefone digitado, a cada mudança do campo.
export function usePhonePoints(http, phone, on) {
  const key = digits(phone);
  const [wallet, setWallet] = useState(null);
  useEffect(() => {
    setWallet(null);
    if (!on || key.length < 10) return undefined;
    let live = true;
    const t = setTimeout(() => {
      http.get(`/loyalty/phone/${key}`).then((r) => { if (live) setWallet(r.data.found && r.data.enabled ? r.data : null); }).catch(() => { if (live) setWallet(null); });
    }, 300);
    return () => { live = false; clearTimeout(t); };
  }, [http, key, on]);
  return { key, wallet };
}

export function loyaltyCalc(lw, sel, freeDel, useLoy, allowFree, fee, room) {
  const points = lw?.mode === "points";
  const rs = rewardSummary(points ? lw : null, sel, freeDel && allowFree, fee);
  const loyOff = !lw ? 0 : points ? Math.min(rs.discount, room) : useLoy ? Math.min(lw.balance, room) : 0;
  return { rs, loyOff };
}

export function LoyaltyBox({ wallet, http, phone, pin, onPin, use, setUse, sel, freeDel, apply, calc, allowFree, color }) {
  const b = wallet;
  if (!b?.enabled || !(b.balance > 0)) return null;
  const points = b.mode === "points";
  const label = points ? `Usar meus pontos (${fmtPts(b.balance)})` : `Usar meu cashback (${brl(b.balance)})`;
  if (!pin) return <PinGate wallet={b} http={http} phone={phone} label={label} color={color} onOk={(p) => { onPin(p); if (!points) setUse(true); }} />;
  if (points) return <PointsBox wallet={b} label={label} startOpen sel={sel} freeDel={freeDel} apply={apply} calc={calc} allowFree={allowFree} color={color} />;
  return (
    <label className="flex items-center gap-3 rounded-xl border p-3 text-sm" data-testid="shop-loyalty-box">
      <Checkbox checked={use} onCheckedChange={(v) => setUse(!!v)} data-testid="shop-use-loyalty" />
      <span className="flex-1">Usar meu cashback: <b>{brl(b.balance)}</b></span>
    </label>
  );
}
